import {
  faDownload,
  faMinus,
  faPlus,
  faTrash,
  faXmark,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormHelperText, Input, Option, Select, Textarea } from "@mui/joy";
import { FormControlLabel, Switch, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Form,
} from "reactstrap";
import SideBar from "../../components/sidebar/Sidebar";
import UserBase from "../../components/user/UserBase";
import "../../css/myestare.css";
import Deletebutton from "./Deletebutton";
import UpdateButton from "./UpdateButton";

import { toast } from "react-toastify";
import {
  formatAmount,
  validateEightDigitNumber,
} from "../../components/Common";
import "../../css/formPOPup.css";
import {
  deleteOtherAsset,
  getOtherAsset,
  otherAsset,
  updateOtherAssetNetWorthStatus,
  updateOtherAssetPublicStatus,
  updateDocumentApi,
} from "../../services/OtherAssetService";
import {
  deleteSingleProperty,
  downloadDocument1,
  fetchNetWorth,
  getBeneficiary,
  getOwnerByUserId,
  getSecondaryUser,
  getToken,
  getTrustByUserId,
  getUser,
} from "../../services/user-service";
import { ConfirmationPopup } from "./ConfirmationPopup";
import { Modal, ModalBody, ModalFooter } from "react-bootstrap";
import SharedBeneficiary from "../../components/SharedBeneficiary";

const getInitialOtherAssetData = () => ({
  otherAsset: {
    owner: "",
    otherAssetListName: "",
    assetCaption: "",
    assetValue: "",
    assetName: "",
    trust: "",
    beneficiaryName: "",
    isPartOfNetWorth: "true",
    isPublic: "false",
    notes: "",
  },
  sharedDetails: [
    {
      distributedType: "",
      distributedValue: "",
      distributedAmount: "",
      beneficiaryId: "",
    },
  ],
});

function OtherAssets() {
  const [otherAssetList, setOtherAssetList] = useState([
    getInitialOtherAssetData(),
  ]);

  const [errors, setErrors] = useState({
    assetValueData: [],
  });
  const [files, setFiles] = useState([]);

  const [modal, setModal] = useState(false);
  const [otherAssetListNameValue, setOtherAssetListNameValue] = useState("");
  const handleChangeAddOtherAssetListName = (event) => {
    const value = event.target.value;
    setOtherAssetListNameValue(value);
  };
  const handleChangeConfirm = () => {
    if (otherAssetListNameValue !== "") {
      setOtherAssetList((prevOtherAssetList) => {
        const updatedOtherAssetList = [...prevOtherAssetList];

        updatedOtherAssetList[0].otherAsset.otherAssetListName =
          otherAssetListNameValue;
        return updatedOtherAssetList;
      });
      setForm1(!form1);
    }
    toggleOtherAssetList();
  };
  const toggleOtherAssetList = () => {
    setModal(false);
  };

  // for owner field
  const [ownerName, setOwnerName] = useState([]);
  const handleChange = (event, newValue, field, index, type = "otherAsset") => {
    if (field === "owner") {
      const ownerString = Array.isArray(newValue)
        ? newValue.join(", ")
        : newValue;

      setOtherAssetList((prevOtherAssetList) =>
        prevOtherAssetList.map((item, i) =>
          i === index
            ? {
                ...item,
                [type]: {
                  ...item[type],
                  owner: ownerString,
                },
              }
            : item
        )
      );

      setOwnerName((prevOwnerNames) => {
        const updatedOwnerNames = [...prevOwnerNames];
        updatedOwnerNames[index] = newValue;
        return updatedOwnerNames;
      });
    }
  };

  // Define an array to store user names
  const [ownerNames, setOwnerNames] = useState([]);

  // Get primaryUser data
  const primaryUserDetails = getUser();
  const primaryUserName =
    primaryUserDetails.firstName + " " + primaryUserDetails.lastName;

  // Get secondaryUser data
  const secondaryUserDetails = getSecondaryUser();
  useEffect(() => {
    const fetchOwnerData = async () => {
      const userId = getUser().commonId;
      const token = "Bearer " + getToken();

      try {
        const resp = await getOwnerByUserId(token, userId);
        // Process data after fetching
        const names = [primaryUserName];

        // Check if secondary user exists
        if (secondaryUserDetails !== undefined) {
          const secondaryUserName = `${secondaryUserDetails.firstName} ${secondaryUserDetails.lastName}`;
          names.push(secondaryUserName);
        }
        resp.forEach((user) => {
          const fullName = `${user.firstName} ${user.lastName}`;
          names.push(fullName);
        });

        // Update ownerNames state
        setOwnerNames(names);
      } catch{
        toast.error("Failed to fetch owner data");
      }
    };

    fetchOwnerData();
  }, []);

  const [assetIndexValue, setAssetIndexValue] = useState(0);
  const [sharedTypeArray, setSharedTypeArray] = useState([]);
  const handleChanges = (e, field, index, type = "otherAsset") => {
    setAssetIndexValue(index);
    const { value } = e.target;
    const errorStates = { ...errors };

    if (!errorStates.assetValueData[index]) {
      errorStates.assetValueData[index] = {
        assetValueValidate: true,
        assetValueZeroValidate: true,
      };
    }

    if (field === "sharedType") {
      setSharedTypeArray((prev) => {
        const updated = [...prev];
        updated[index] = value;
        return updated;
      });

      setOtherAssetList((prevOtherAssetList) => {
        const updatedJewelries = [...prevOtherAssetList];
        updatedJewelries[index].sharedDetails = [
          {
            distributedType: "",
            distributedValue: "",
            distributedAmount: "",
            beneficiaryId: "",
          },
        ];
        return updatedJewelries;
      });
      setOtherAssetList((prevOtherAssetList) =>
        prevOtherAssetList.map((otherAsset, i) => {
          return i === index
            ? {
                ...otherAsset,
                [type]: {
                  ...otherAsset[type],
                  trust: "",
                },
              }
            : otherAsset;
        })
      );
      setOtherAssetList((prevOtherAssetList) =>
        prevOtherAssetList.map((otherAsset, i) => {
          return i === index
            ? {
                ...otherAsset,
                [type]: {
                  ...otherAsset[type],
                  beneficiaryName: "",
                },
              }
            : otherAsset;
        })
      );
    } else {
      if (field === "assetValue") {
        errorStates.assetValueData[index].assetValueValidate =
          value !== "" ? validateEightDigitNumber(value) : true;
        errorStates.assetValueData[index].assetValueZeroValidate =
          value !== "" ? Number(value) > 0 : true;
      }

      setOtherAssetList((prevOtherAssetList) =>
        prevOtherAssetList.map((otherAsset, i) => {
          // If the field is "otherAssetListName" and the length is greater than 0
          if (field === "otherAssetListName" && prevOtherAssetList.length > 0) {
            return {
              ...otherAsset,
              [type]: {
                ...otherAsset[type],
                otherAssetListName: value, // Set otherAssetListName to the new value for all items
              },
            };
          }

          // Default behavior for other fields
          return i === index
            ? {
                ...otherAsset,
                [type]: {
                  ...otherAsset[type],
                  [field]: value,
                },
              }
            : otherAsset;
        })
      );
    }
    setErrors(errorStates);
  };


  const resetForm = () => {
    setFiles([]);
    setOwnerName([]);
    setOtherAssetList([getInitialOtherAssetData()]);
    setOtherAssetListNameValue("");
    setErrors({
      assetValueData: [],
    });
  };

  const funcNetWorthStatus = () => {
    updateOtherAssetNetWorthStatus(
      existingOtherAssetListName,
      isChecked === true ? "false" : "true"
    )
      .then((resp) => {
        toast.success(resp, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        AddCard();
      })
      .catch((error) => {});
  };

  const [isChecked, setIsChecked] = useState(null);
  const handleSwitchChange = () => {
    setIsChecked(!isChecked);
    funcNetWorthStatus();
  };

   const [isPublic, setIsPublic] = useState(false);

     const handleSwitchChange1 = () => {
       const newStatus = !isPublic;
       setIsPublic(newStatus);
       funcPublicStatus(newStatus);
     };

     const funcPublicStatus = (newStatus) => {
       if (!Array.isArray(showDetail) || showDetail.length === 0) return;

       const listName = showDetail[0].otherAsset.otherAssetListName;
       const newStatusString = newStatus ? "true" : "false";

       updateOtherAssetPublicStatus(listName, newStatusString)
         .then(() => {
           toast.success("Public status updated successfully", {
             position: toast.POSITION.BOTTOM_CENTER,
           });

           const updatedShowDetail = showDetail.map((item) => ({
             ...item,
             otherAsset: { ...item.otherAsset, isPublic: newStatusString },
           }));
           setShowDetail(updatedShowDetail);

           AddCard();
         })
         .catch(() => {
           toast.error("Failed to update public status", {
             position: toast.POSITION.BOTTOM_CENTER,
           });
           setIsPublic(!newStatus);
         });
     };

  // Set the form
  const otherAssestForm = (event) => {
    event.preventDefault();

    const hasErrors = errors.assetValueData.some(
      (assetValue) =>
        !assetValue.assetValueValidate || !assetValue.assetValueZeroValidate
    );

    if (!hasErrors) {
      let token = "Bearer " + getToken();
      // create form data to send a file and remaining class data
      const formData = new FormData();

      formData.append("data", JSON.stringify(otherAssetList));

      Object.keys(files).forEach((index) => {
        files[index].forEach((file) => {
          formData.append(`files${index}`, file);
        });
      });

      otherAsset(formData, token)
        .then((resp) => {
          AddCard();
          toast.success("Data Added !!", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          fetchNetWorth(primaryUserDetails.commonId);
          toggle(null, null, null, "close");
        })
        .catch((error) => {
         });
    }
  };

  const [showConfirmationDelete, setShowConfirmationDelete] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [currentIdType, setCurrentIdType] = useState("");
  const removeOtherAsset = (id, idType) => {
    setShowConfirmationDelete(true);
    setCurrentId(id);
    setCurrentIdType(idType);
  };

  const handleConfirmationDeleteClose = () => {
    setShowConfirmationDelete(false);
  };

  const handleRemove = (params) => {
    setShowConfirmationDelete(false);
    const { Id, idType } = params;
    if (idType === "otherAssetId") {
      deleteOtherAsset(Id)
        .then((res) => {
          toast.success("Deleted successfully...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          AddCard();
          setShow1(false);
        })
        .catch((error) => {
         });
    } else {
      deleteSingleProperty(Id)
        .then((res) => {
          setBeneficiaryVisible(!beneficiaryVisible);
          setShow1(false);
          AddCard();
          toast.success("Deleted successfully...", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        })
        .catch((error) => {
         });
    }
  };

  const handleDownload = (id, fileName) => {
    let myarry = fileName.split(".");

    downloadDocument1(id)
      .then((response) => {
         const downloadUrl = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `${myarry[0]}.${myarry[1]}`;
        link.click();
        URL.revokeObjectURL(downloadUrl);
      })
      .catch((error) => {});
  };

  const [show, setShow] = useState(true);

  // show notes popup
  const [popupVisible, setPopupVisible] = useState(false);
  const [selectedNote, setSelectedNote] = useState("");

  const handleOpenPopup = (note) => {
    setSelectedNote(note);
    setPopupVisible(true);
  };

  // for multiple download
  const [popupVisibleDownlaod, setPopupVisibleDownlaod] = useState(false);
  const [selectedDownlaod, setSelectDownload] = useState("");

  const handleShowDownlaod = (showDetail) => {
    setPopupVisibleDownlaod(true);
    setSelectDownload(showDetail);
  };

  let [form1, setForm1] = useState(false);

  const [existingOtherAssetListName, setExistingOtherAssetListName] =
    useState(null);
  const [existingIsPartOfNetWorthValue, setExistingIsPartOfNetWorthValue] =
    useState(null);
    const [existingIsPublic, setExistingIsPublic] = useState(null);
  const toggle = (event, value, isPartOfNetWorthValue, closePopup) => {
    setExistingOtherAssetListName(value);
    setExistingIsPartOfNetWorthValue(isPartOfNetWorthValue);
    setExistingIsPublic(isPublic);
    resetForm();
    if (closePopup) {
      setForm1(false);
      setOtherAssetListNameValue("");
      setExistingIsPartOfNetWorthValue("");
      return;
    }
    if (value) {
      setForm1(true);
    } else {
      if (otherAssetListNameValue !== "") {
        setForm1(false);
      } else {
        setModal(true);
      }
    }
  };

  useEffect(() => {
    if (existingOtherAssetListName) {
      setOtherAssetList((prevOtherAssetList) =>
        prevOtherAssetList.map((item) => ({
          ...item,
          otherAsset: {
            ...item.otherAssetListName,
            otherAssetListName: existingOtherAssetListName, // Set the new jewelryListName
            isPartOfNetWorth: existingIsPartOfNetWorthValue,
            isPublic: existingIsPublic,
          },
        }))
      );
    }
  }, [existingOtherAssetListName ,existingIsPartOfNetWorthValue, existingIsPublic]);

  // cards
  let [card, setCard] = useState([]); // card = [ {} , {} , {}] - include the form data going to use it for card
  let [showDetail, setShowDetail] = useState([]); // this is to display the card details
  let [show1, setShow1] = useState(false);

  // card creating
  const AddCard = () => {
    let userId = getUser().commonId;
    let token = "Bearer " + getToken(); // Added 'Bearer'
    getOtherAsset(token, userId)
      .then((res) => {
        setCard(res);
      })
      .catch(() => {
        setCard([]);
        toast.error("Error"); // Changed to toast.error for better visibility of errors
      });
  };

  // showing the details of cards like popup
  const Showdetails = (obj) => {
    // const arrayFromObject = Object.keys(obj).map(key => obj[key]);
    setShowDetail(obj);
    setShow1(true);
    setIsChecked(
      obj[0].otherAsset.isPartOfNetWorth !== null
        ? obj[0].otherAsset.isPartOfNetWorth === "true"
          ? true
          : false
        : true
    );
    setIsPublic(obj[0].otherAsset.isPublic === "true");
    setExistingOtherAssetListName(obj[0].otherAsset.otherAssetListName);
    setExistingIsPublic(obj[0].otherAsset.isPublic);
  };

  // beneficiary addition in form
  const [beneficiary, setBenificiary] = useState([]);

  const getBenificiarydata = () => {
    let userId = getUser().commonId;

    let token = "Bearer " + getToken();
    getBeneficiary(token, userId)
      .then((res) => {
        setBenificiary(res);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    AddCard();
    getBenificiarydata();
    getTrustsData();
  }, []);

  // for add field pop
  let [showAdditionField, SetshowAdditionField] = useState(false);
  // for assests show
  let [showAssets, SetshowAssets] = useState(false);

  //
  const [benevisible, setbeneVisible] = useState(false);
  const [beneficiaryVisible, setBeneficiaryVisible] = useState(false);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState("");

  const handleShowBeneficiary = (event, indexValue) => {
    setShow1(false);
    setAssetIndexValue(indexValue);
    setbeneVisible(true);
  };
  const handleOpenBeneficiary = (showDetail) => {
    setSelectedBeneficiary(showDetail);
    setBeneficiaryVisible(true);
  };

  const handleCloseBeneficiaryPopup = (params) => {
    const { name } = params;
    if (name !== undefined) {
      setOtherAssetList((prev) => {
        const updatedJewelries = [...prev];
        updatedJewelries[assetIndexValue].sharedDetails = name;
        return updatedJewelries;
      });
    }
    setbeneVisible(false);
  };

  const handleReset = () => {
    setbeneVisible(false);
  };

  const [trusts, setTrusts] = useState([]);
  const getTrustsData = () => {
    let userId = getUser().commonId;

    let token = "Bearer " + getToken();
    getTrustByUserId(token, userId)
      .then((res) => {
        setTrusts(res);
      })
      .catch((err) => {});
  };
  const handleTrustSave = () => {
    setbeneVisible(false);
  };
  const getBenificiaryName = (id) => {
    var foundBenificiary = null;
    if (id.beneficiary === undefined) {
      foundBenificiary = beneficiary.find((b) => b.id === parseInt(id));
    } else {
      foundBenificiary = beneficiary.find(
        (b) => b.id === parseInt(id.beneficiary)
      );
    }
    if (foundBenificiary) {
      return `${foundBenificiary.firstName} ${foundBenificiary.lastName}`;
    } else {
      return "Benificiary not found";
    }
  };



  const addOtherAssetRow = () => {
    setOtherAssetList((prevOtherAssetList) => [
      ...prevOtherAssetList,
      {
        ...getInitialOtherAssetData(),
        otherAsset: {
          ...getInitialOtherAssetData().otherAsset,
          otherAssetListName:
            prevOtherAssetList[0]?.otherAsset.otherAssetListName || "",
          isPartOfNetWorth:
            prevOtherAssetList[0]?.otherAsset.isPartOfNetWorth || "",
          isPublic: prevOtherAssetList[0]?.otherAsset.isPublic || "false",
        },
        sharedDetails: [
          {
            distributedType: "",
            distributedValue: "",
            distributedAmount: "",
            beneficiaryId: "",
          },
        ],
      },
    ]);

    setErrors((prevErrors) => ({
      ...prevErrors,
      assetValueData: [
        ...prevErrors.assetValueData,
        { assetValueValidate: true, assetValueZeroValidate: true },
      ],
    }));
  };

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const removeOtherAssetRow = (index) => {
    setShowConfirmation(true);
    setCurrentIndex(index);
  };

  const handleConfirmation = () => {
    setShowConfirmation(false);
    const index = currentIndex;
    setOtherAssetList(otherAssetList.filter((_, i) => i !== index));

    setFiles((prevFiles) => {
      const updatedFiles = Object.keys(prevFiles).reduce((acc, key) => {
        const numericKey = parseInt(key, 10);
        if (numericKey !== index) {
          const newIndex = numericKey > index ? numericKey - 1 : numericKey;
          acc[newIndex] = prevFiles[key];
        }
        return acc;
      }, {});

      return updatedFiles;
    });

    // Update ownerName by shifting indices after removal
    setOwnerName((prevOwnerNames) => {
      const updatedOwnerNames = prevOwnerNames.filter((_, i) => i !== index);
      return updatedOwnerNames;
    });

    setErrors((prevErrors) => {
      const updatedAssetValueData = prevErrors.assetValueData.filter(
        (_, i) => i !== index
      );

      return {
        ...prevErrors,
        assetValueData: updatedAssetValueData,
      };
    });
  };

  const handleConfirmationClose = () => {
    setShowConfirmation(false);
  };

  // Group and consolidate data
  const consolidated = card.reduce((acc, item) => {
    const listName = item.otherAsset.otherAssetListName;
    const partOfNetWorthValue = item.otherAsset.isPartOfNetWorth;
    const isPublicValue = item.otherAsset.isPublic;
    const assetValue = parseFloat(item.otherAsset.assetValue);

    if (!acc[listName]) {
      acc[listName] = {
        otherAssetListName: listName,
        isPartOfNetWorth: partOfNetWorthValue,
        isPublic: isPublicValue,
        assetValue: 0,
        data: [],
      };
    }
acc[listName].assetValue += assetValue;
    acc[listName].data.push({
      otherAsset: item.otherAsset,
      documents: item.documents,
      sharedDetails: item.sharedDetails,
    });

    return acc;
  }, {});

const uniqueListDocuments = showDetail && Array.isArray(showDetail)
  ? [...new Map(
      showDetail.flatMap(item => item.documents || [])
      .map(doc => [doc.id, doc])
    ).values()]
  : [];
   const [viewDetailFile, setViewDetailFile] = useState(null);

       const handleUnifiedDocumentUpload = () => {
         if (!viewDetailFile) {
           toast.error("Please select a file to upload");
           return;
         }

         const maxFileSize = 4 * 1024 * 1024;

         if (viewDetailFile.size > maxFileSize) {
           toast.error("Please upload a PDF under 4 MB.", {
             position: toast.POSITION.BOTTOM_CENTER,
           });
           return;
         }

         const listName = showDetail[0].otherAsset.otherAssetListName;
         const token = "Bearer " + getToken();
         const formData = new FormData();

         formData.append("file", viewDetailFile);
         formData.append("listName", listName);

         updateDocumentApi(formData, token)
           .then(() => {
             toast.success("Documents updated successfully!", {
               position: toast.POSITION.BOTTOM_CENTER,
             });
             setViewDetailFile(null);
             AddCard();
             setShow1(false);
           })
           .catch((error) => {
             console.error(error);
             toast.error("Failed to update documents");
           });
       };

  // Convert consolidated object to an array
  const uniqueOtherAssetListResult = Object.values(consolidated);

  return (
    <div className={`your-component ${show ? "fade-in-element" : ""}`}>
      <UserBase>
        <div className="mt-5"></div>
        <SideBar>
          {primaryUserDetails.accountType === "secondary" &&
          secondaryUserDetails.accountType === "primary" &&
          secondaryUserDetails.isSecondaryUserEditable === "false" ? (
            ""
          ) : (
            <div className="addme">
              <div className="addme_inner">
                <button onClick={() => toggle()}>Add New Assets</button>
              </div>
            </div>
          )}

          <div className="propCard">
            <div className="propCard-card">
              {uniqueOtherAssetListResult.map((item, index) => (
                <div
                  className="propCard-card-body"
                  style={{ padding: "20px 20px 10px 20px" }}
                >
                  <div className="propCard_card_status">
                    <p
                      className={`propCard_card_status_text ${
                        item.data.every(
                          (dataItem) =>
                            (dataItem.otherAsset.trust &&
                              dataItem.otherAsset.trust !== "" &&
                              dataItem.otherAsset.trust !== null) ||
                            (dataItem.otherAsset.beneficiaryName &&
                              dataItem.otherAsset.beneficiaryName !== "" &&
                              dataItem.otherAsset.beneficiaryName !== null) ||
                            (dataItem.sharedDetails &&
                              dataItem.sharedDetails.length > 0 &&
                              dataItem.sharedDetails[0].distributedType !== "")
                        )
                          ? "completed"
                          : "incomplete"
                      }`}
                    >
                      {item.data.every(
                        (dataItem) =>
                          (dataItem.otherAsset.trust &&
                            dataItem.otherAsset.trust !== "" &&
                            dataItem.otherAsset.trust !== null) ||
                          (dataItem.otherAsset.beneficiaryName &&
                            dataItem.otherAsset.beneficiaryName !== "" &&
                            dataItem.otherAsset.beneficiaryName !== null) ||
                          (dataItem.sharedDetails &&
                            dataItem.sharedDetails.length > 0 &&
                            dataItem.sharedDetails[0].distributedType !== "")
                      )
                        ? "completed"
                        : "incomplete"}
                    </p>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <h5 className="propCard-card-title">
                    {item.otherAssetListName}
                  </h5>
                    <span style={{ color: "green" }}>
                      {formatAmount(item.assetValue)}
                    </span>
                  </div>
                  <div className="propCard-btn">
                    <p className="viewDetails">
                      <button
                        className="jewelry_add_more"
                        onClick={(event) =>
                          toggle(
                            event,
                            item.otherAssetListName,
                            item.isPartOfNetWorth
                          )
                        }
                      >
                        Add More
                      </button>
                      <button
                        style={{ margin: "10px 0" }}
                        onClick={() => Showdetails(item.data)}
                      >
                        View Details
                      </button>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {form1 && (
            <div
              className="overlay1"
              style={{ transition: "500ms", height: "" }}
            >
              <div>
                <Form onSubmit={otherAssestForm} className="addform_body">
                  <container>
                    <div className="homepage jewelry_container">
                      <Card>
                        <CardHeader>
                          <div
                            style={{ width: "100%" }}
                            className="addform_heading"
                          >
                            <h3 className="addform_heading_h1">
                              {otherAssetListNameValue &&
                                otherAssetListNameValue}
                              {existingOtherAssetListName &&
                                existingOtherAssetListName}
                            </h3>
                            <div
                              className="addform_close"
                              onClick={(event) =>
                                toggle(event, "", "", "close")
                              }
                            >
                              <FontAwesomeIcon icon={faXmark} />
                            </div>
                          </div>
                        </CardHeader>
                        <CardBody className="jewelry_card_body">
                          <div>
                            <table className="jewelry_table">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th className="otherAsset_th ">
                                    Select Owner*
                                  </th>
                                  <th className="otherAsset_th otherAsset_150px">
                                    Asset Caption
                                  </th>
                                  <th className="otherAsset_th otherAsset_150px">
                                    Asset Name*
                                  </th>
                                  <th className="otherAsset_th otherAsset_150px">
                                    Asset Value*
                                  </th>
                                  <th style={{ width: "190px" }}>
                                    Select Your Beneficiary*
                                  </th>
                                  <th className="otherAsset_th">Notes</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {otherAssetList.map((row, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      <Select
                                        className="jewelry_select"
                                        placeholder="Select Owner"
                                        value={ownerName[index] || []}
                                        multiple
                                        onChange={(event, newValue) =>
                                          handleChange(
                                            event,
                                            newValue,
                                            "owner",
                                            index,
                                            "otherAsset"
                                          )
                                        }
                                        required
                                      >
                                        {ownerNames.map((name) => (
                                          <Option key={name} value={name}>
                                            {name}
                                          </Option>
                                        ))}
                                      </Select>
                                    </td>

                                    <td>
                                      <Input
                                        className="otherAsset_input otherAsset_150px"
                                        placeholder="Asset Caption"
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "assetCaption",
                                            index,
                                            "otherAsset"
                                          )
                                        }
                                        value={
                                          otherAssetList[index]?.otherAsset
                                            ?.assetCaption || ""
                                        }
                                      />
                                    </td>

                                    <td>
                                      <Input
                                        className="otherAsset_input otherAsset_150px"
                                        type="text"
                                        placeholder="Asset Name"
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "assetName",
                                            index,
                                            "otherAsset"
                                          )
                                        }
                                        value={
                                          otherAssetList[index]?.otherAsset
                                            ?.assetName || ""
                                        }
                                        required
                                      />
                                    </td>
                                    <td>
                                      <Input
                                        className="otherAsset_input otherAsset_150px"
                                        id={`assetValue${index}`}
                                        placeholder="Asset Value"
                                        type="number"
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "assetValue",
                                            index,
                                            "otherAsset"
                                          )
                                        }
                                        value={
                                          otherAssetList[index]?.otherAsset
                                            ?.assetValue || ""
                                        }
                                        startDecorator={<div>$</div>}
                                        required
                                      />
                                      {errors.assetValueData.length > index &&
                                        (!errors?.assetValueData[index]
                                          .assetValueValidate ||
                                          !errors?.assetValueData[index]
                                            .assetValueZeroValidate) && (
                                          <FormHelperText error>
                                            <Typography
                                              variant="caption"
                                              color="error"
                                            >
                                              {!errors?.assetValueData[index]
                                                .assetValueValidate
                                                ? "Must be less than: $99,999,999."
                                                : !errors?.assetValueData[index]
                                                    .assetValueZeroValidate
                                                ? "Value can't be zero"
                                                : ""}
                                            </Typography>
                                          </FormHelperText>
                                        )}
                                    </td>

                                    <td style={{ width: "190px" }}>
                                      <div
                                        style={{ width: "190px" }}
                                        className="bene-select beneficiary_btn"
                                        onClick={(e) =>
                                          handleShowBeneficiary(e, index)
                                        }
                                      >
                                        Select Your Beneficiary
                                      </div>
                                    </td>
                                    <td>
                                      <Textarea
                                        style={{ fontSize: "14px" }}
                                        placeholder="Notes"
                                        id="notes"
                                        onChange={(e) =>
                                          handleChanges(
                                            e,
                                            "notes",
                                            index,
                                            "otherAsset"
                                          )
                                        }
                                        value={
                                          otherAssetList[index]?.otherAsset
                                            ?.notes || ""
                                        }
                                      />
                                    </td>
                                    <td>
                                      <div className="jewelry_action">
                                        {otherAssetList.length > 1 && (
                                          <Button
                                            className="jewelry_remove_button"
                                            onClick={() =>
                                              removeOtherAssetRow(index)
                                            }
                                          >
                                            <FontAwesomeIcon icon={faMinus} />
                                          </Button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            <div style={{ marginTop: "8px" }}>
                              <Button
                                className="jewelry_add_more_button"
                                type="button"
                                onClick={addOtherAssetRow}
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </Button>
                            </div>
                          </div>
                        </CardBody>
                        <CardFooter>
                          <div className="text-center">
                            <Button
                              className="my-estate-clear-btn"
                              onClick={resetForm}
                              type="reset"
                              outline
                            >
                              Clear
                            </Button>
                            <Button
                              outline
                              type=""
                              className="my-estate-add-btn"
                            >
                              Add
                            </Button>
                          </div>
                        </CardFooter>
                      </Card>
                    </div>
                  </container>
                </Form>
              </div>
            </div>
          )}

          {modal && (
            <div>
              <Modal
                show={modal}
                toggle={toggleOtherAssetList}
                style={{ paddingTop: "50px" }}
              >
                <ModalBody style={{ color: "black" }}>
                  Please create your miscellaneous asset list here:
                  <div>
                    <Input
                      type="text"
                      value={otherAssetListNameValue}
                      placeholder="Enter your miscellaneous asset list name"
                      onChange={handleChangeAddOtherAssetListName}
                    />
                  </div>
                </ModalBody>
                <ModalFooter style={{ padding: "5px" }}>
                  <Button
                    className="confirm_delete_btn"
                    onClick={handleChangeConfirm}
                  >
                    Add
                  </Button>{" "}
                  <Button
                    className="confirm_cancel_btn"
                    onClick={toggleOtherAssetList}
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </Modal>
            </div>
          )}

          {showConfirmation && (
            <ConfirmationPopup
              handleConfirmation={handleConfirmation}
              handleConfirmationClose={handleConfirmationClose}
              anyText="Do you want to remove item from this list?"
            />
          )}

          {showConfirmationDelete && (
            <Deletebutton
              handleRemove={handleRemove}
              Id={currentId}
              idType={currentIdType}
              handleConfirmationClose={handleConfirmationDeleteClose}
            />
          )}

          {show1 && (
            <>
              <div className="popup">
                <div className="popup-content popup-content-download">
                  <div className="note_popup">
                    <div className="note_popup_heading">
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <h2>{`${showDetail[0]?.otherAsset?.otherAssetListName} Details`}</h2>
                      </div>
                      <div>
                        <button
                          className="note_popup_heading_close_btn"
                          onClick={() => {
                            setShow1(false);
                          }}
                        >
                          <FontAwesomeIcon icon={faXmark} />
                        </button>
                      </div>
                    </div>
                    <div
                      style={{ margin: "5px" }}
                      className="mt-2 switch_changes_main"
                    >
                      <div className="switch_changes_base">
                        <div>
                          Do you want to include the total list value as part of
                          your net worth?
                        </div>
                        <div>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={isChecked}
                                onChange={(event) => {
                                  handleSwitchChange(event);
                                }}
                                color="primary"
                                size="normal"
                              />
                            }
                            label={isChecked ? "Yes" : "No"}
                            labelPlacement="end"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                                        style={{ margin: "5px" }}
                                                              className="mt-2 switch_changes_main"
                                                            >
                                                              <div className="switch_changes_base">
                                                                <div>
                                                                  Do you want this asset to be visible to your agent?
                                                                </div>
                                                                <div>
                                                          <FormControlLabel
                                                                    control={
                                                                      <Switch
                                                                        checked={isPublic}
                                                                        onChange={(event) => {
                                                                          handleSwitchChange1(event);
                                                                        }}
                                                                        color="primary"
                                                                        size="normal"
                                                                      />
                                                                    }
                                                                    label={isPublic ? "Yes" : "No"}
                                                                    labelPlacement="end"
                                                                  />
                                                                </div>
                                                              </div>
                                                            </div>

                                                            <div
                                                                                                                          style={{ margin: "5px" }}
                                                                                                                          className="mt-2 switch_changes_main"
                                                                                                                        >
                                                                                                                          <div className="switch_changes_base">
                                                                                                                            <div>
                                                                                                                              Upload Document for this List:
                                                                                                                            </div>
                                                                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                                                                              <input
                                                                                                                                type="file"
                                                                                                                                accept=".pdf"
                                                                                                                                onChange={(e) => setViewDetailFile(e.target.files[0])}
                                                                                                                                style={{ maxWidth: '200px' }}
                                                                                                                              />
                                                                                                                              <Button
                                                                                                                                color="primary"
                                                                                                                                size="sm"
                                                                                                                                onClick={handleUnifiedDocumentUpload}
                                                                                                                                disabled={!viewDetailFile}
                                                                                                                              >
                                                                                                                                <FontAwesomeIcon icon={faUpload} className="me-2" />
                                                                                                                                Upload
                                                                                                                              </Button>
                                                                                                                            </div>
                                                                                                                          </div>
                                                                                                                        </div>
                                                                                                                        {uniqueListDocuments.length > 0 && (
                                                                                                                          <div style={{ margin: "5px" }} className="mt-2 switch_changes_main">
                                                                                                                            <div className="switch_changes_base">
                                                                                                                              <div>Download Documents for this List:</div>
                                                                                                                              <div style={{ display: "flex", alignItems: "center" }}>
                                                                                                                                <div className="me-2">
                                                                                                                                  <Tooltip title="click to see multiple download files">
                                                                                                                                    <div
                                                                                                                                      style={{ cursor: "pointer" }}
                                                                                                                                      onClick={() => {
                                                                                                                                        handleShowDownlaod({ documents: uniqueListDocuments });
                                                                                                                                        setShow1(false);
                                                                                                                                      }}
                                                                                                                                    >
                                                                                                                                      <div className="myestate_download_button dwnbtn">
                                                                                                                                        <FontAwesomeIcon
                                                                                                                                          className="myestate_download_icon"
                                                                                                                                          icon={faDownload}
                                                                                                                                        />
                                                                                                                                        <span></span>
                                                                                                                                      </div>
                                                                                                                                    </div>
                                                                                                                                  </Tooltip>
                                                                                                                                </div>
                                                                                                                              </div>
                                                                                                                            </div>
                                                                                                                          </div>
                                                                                                                        )}
                    <div>
                      {showDetail.map((details, index) => (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            margin: "5px",
                            padding: "10px",
                            border: "solid 1px lightgray",
                            borderRadius: "5px",
                            minWidth: "230px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            {/* Left side */}
                            <div>
                              <p
                                style={{
                                  fontSize: "17px",
                                  color: "black",
                                  fontWeight: "500",
                                }}
                              >
                                {`Item - ${index + 1}`}
                                {"  "}
                                <span
                                  className={`propCard_card_status_text ${
                                    (details.otherAsset.trust &&
                                      details.otherAsset.trust !== "" &&
                                      details.otherAsset.trust !== null) ||
                                    (details.otherAsset.beneficiaryName &&
                                      details.otherAsset.beneficiaryName !== "" &&
                                      details.otherAsset.beneficiaryName !== null) ||
                                    (details.sharedDetails &&
                                      details.sharedDetails.length > 0 &&
                                      details.sharedDetails[0].distributedType !== "")
                                      ? "completed"
                                      : "incomplete"
                                  }`}
                                >
                                  {(details.otherAsset.trust &&
                                    details.otherAsset.trust !== "" &&
                                    details.otherAsset.trust !== null) ||
                                  (details.otherAsset.beneficiaryName &&
                                    details.otherAsset.beneficiaryName !== "" &&
                                    details.otherAsset.beneficiaryName !== null) ||
                                  (details.sharedDetails &&
                                    details.sharedDetails.length > 0 &&
                                    details.sharedDetails[0].distributedType !== "")
                                    ? "completed"
                                    : "incomplete"}
                                </span>
                              </p>
                            </div>
                            {/* Right side */}
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {primaryUserDetails.accountType === "secondary" &&
                              secondaryUserDetails.accountType === "primary" &&
                              secondaryUserDetails.isSecondaryUserEditable ===
                                "false" ? (
                                ""
                              ) : (
                                <div className="me-2">
                                  <Tooltip title="Click Here To Edit">
                                    <div>
                                      <UpdateButton
                                        URL={"../my-estate/otherAsset/"}
                                        id={details.otherAsset.id}
                                      />
                                    </div>
                                  </Tooltip>
                                </div>
                              )}

                              {primaryUserDetails.accountType === "secondary" &&
                              secondaryUserDetails.accountType === "primary" &&
                              secondaryUserDetails.isSecondaryUserEditable ===
                                "false" ? (
                                ""
                              ) : (
                                <FontAwesomeIcon
                                  onClick={() =>
                                    removeOtherAsset(
                                      details.otherAsset.id,
                                      "otherAssetId"
                                    )
                                  }
                                  className="delete-button-comp"
                                  style={{ cursor: "pointer" }}
                                  icon={faTrash}
                                />
                              )}
                            </div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",

                              flexWrap: "wrap", // Allow wrapping to next line if needed
                            }}
                            className="mt-2"
                          >
                            {/* Left section */}
                            <div style={{ flex: "1", minWidth: "250px" }}>
                              {details.otherAsset.owner && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Owner :{" "}
                                  {details.otherAsset.owner && (
                                    <span>{details.otherAsset.owner}</span>
                                  )}
                                </p>
                              )}

                              {details.otherAsset.assetName && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Asset Name :{" "}
                                  <span>
                                    {details.otherAsset.assetName && (
                                      <span>
                                        {details.otherAsset.assetName}
                                      </span>
                                    )}
                                  </span>
                                </p>
                              )}

                              <p style={{ color: "black", fontWeight: "500" }}>
                                Asset Value :{" "}
                                <span>
                                  {details.otherAsset.assetValue && (
                                    <span
                                      style={{
                                        color: "green",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {formatAmount(
                                        details.otherAsset.assetValue
                                      )}
                                    </span>
                                  )}
                                </span>
                              </p>
                            </div>

                            {/* Right section */}
                            <div style={{ flex: "0.5", minWidth: "250px" }}>
                              {details.otherAsset.assetCaption && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Asset Caption :{" "}
                                  <span>
                                    {details.otherAsset.assetCaption && (
                                      <span>
                                        {details.otherAsset.assetCaption}
                                      </span>
                                    )}
                                  </span>
                                </p>
                              )}

                              {details.sharedDetails[0] && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                  onClick={() => {
                                    handleOpenBeneficiary(details);
                                    setShow1(false);
                                  }}
                                >
                                  Beneficiary Details{" "}
                                  <span>
                                    <span className="readmore">Click Here</span>
                                  </span>
                                </p>
                              )}

                              {details.otherAsset.trust && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Trust Name:{" "}
                                  {details.otherAsset.trust && (
                                    <span>{details.otherAsset.trust}</span>
                                  )}
                                </p>
                              )}

                              {details.otherAsset.beneficiaryName && (
                                <p
                                  style={{ color: "black", fontWeight: "500" }}
                                >
                                  Beneficiary Name:{" "}
                                  {details.otherAsset.beneficiaryName && (
                                    <span>
                                      {details.otherAsset.beneficiaryName}
                                    </span>
                                  )}
                                </p>
                              )}

                              {details.otherAsset.notes && (
                                <Tooltip title="Click To see Note">
                                  <p
                                    style={{
                                      color: "black",
                                      fontWeight: "500",
                                    }}
                                    onClick={() => {
                                      handleOpenPopup(details.otherAsset.notes);
                                      setShow1(!show1);
                                    }}
                                  >
                                    Note:{" "}
                                    <span>
                                      {" "}
                                      {details && details.otherAsset.notes
                                        ? details.otherAsset.notes.slice(0, 5)
                                        : ""}
                                      ...
                                      <span className="readmore">
                                        Read More
                                      </span>
                                    </span>
                                  </p>
                                </Tooltip>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/*  download popup */}
          {popupVisibleDownlaod && (
            <div className="popup">
              <div className="popup-content popup-content-download">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <h2>Download Files</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setPopupVisibleDownlaod(false);
                          setShow(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>

                  <div>
                    <div style={{ marginBottom: "20px" }}>
                      <Tooltip title={selectedDownlaod.name}>
                        <div
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            gap: "20px",
                          }}
                          onClick={() => {
                            handleDownload(selectedDownlaod.name, 0);
                          }}
                        >
                          Downlaod - 1
                          <div className="myestate_download_button dwnbtn">
                            <FontAwesomeIcon
                              className="myestate_download_icon"
                              icon={faDownload}
                            />
                            <span>{selectedDownlaod.name}</span>
                          </div>
                        </div>
                      </Tooltip>
                    </div>

                    {selectedDownlaod.name1 && (
                      <div style={{ marginBottom: "20px" }}>
                        <Tooltip title={selectedDownlaod.name1}>
                          <div
                            //  value = {showDetail.user.id}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              gap: "20px",
                            }}
                            onClick={() => {
                              handleDownload(selectedDownlaod.name1, 1);
                            }}
                          >
                            Downlaod - 2
                            <div className="myestate_download_button dwnbtn">
                              <FontAwesomeIcon
                                className="myestate_download_icon"
                                icon={faDownload}
                              />
                              <span>{selectedDownlaod.name1}</span>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    )}

                    {selectedDownlaod.name2 && (
                      <div style={{ marginBottom: "20px" }}>
                        <Tooltip title={selectedDownlaod.name2}>
                          <div
                            //  value = {showDetail.user.id}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              gap: "20px",
                            }}
                            onClick={() => {
                              handleDownload(selectedDownlaod.name2, 2);
                            }}
                          >
                            Download - 3
                            <div className="myestate_download_button dwnbtn">
                              <FontAwesomeIcon
                                className="myestate_download_icon"
                                icon={faDownload}
                              />
                              <span>{selectedDownlaod.name2}</span>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    )}

                    {selectedDownlaod.name3 && (
                      <div style={{ marginBottom: "20px" }}>
                        <Tooltip title={selectedDownlaod.name3}>
                          <div
                            //  value = {showDetail.user.id}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              gap: "20px",
                            }}
                            onClick={() => {
                              handleDownload(selectedDownlaod.name3, 3);
                            }}
                          >
                            Download - 4
                            <div className="myestate_download_button dwnbtn">
                              <FontAwesomeIcon
                                className="myestate_download_icon"
                                icon={faDownload}
                              />
                              <span>{selectedDownlaod.name3}</span>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    )}

                    {selectedDownlaod.name4 && (
                      <div style={{ marginBottom: "20px" }}>
                        <Tooltip title={selectedDownlaod.name4}>
                          <div
                            //  value = {showDetail.user.id}
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              gap: "20px",
                            }}
                            onClick={() => {
                              handleDownload(selectedDownlaod.name4, 4);
                            }}
                          >
                            Downlaod - 5
                            <div className="myestate_download_button dwnbtn">
                              <FontAwesomeIcon
                                className="myestate_download_icon"
                                icon={faDownload}
                              />
                              <span>{selectedDownlaod.name4}</span>
                            </div>
                          </div>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {popupVisible && (
            // Popup div
            <div className="popup">
              <div className="popup-content">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div>
                      <h2>Notes</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setPopupVisible(false);
                          setShow1(!show1);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>
                  <div>
                    <p>{selectedNote}</p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showAdditionField && (
            // Display the popup when a row is selected
            <div className="popup">
              <div className="popup-content">
                <div className="note_popup_heading">
                  <div>
                    <h2>All Additional Field</h2>
                  </div>
                  <div>
                    <button
                      className="note_popup_heading_close_btn"
                      onClick={() => {
                        SetshowAdditionField(false);
                        setShow1(!show1);
                      }}
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  </div>
                </div>
                <div className="popup-body">
                  {showAdditionField.addfield1 !== 0 &&
                  showAdditionField.addfield1 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      New Field 1 : {showAdditionField.addfield1}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAdditionField.addfield2 !== 0 &&
                  showAdditionField.addfield2 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      New Field 2 : {showAdditionField.addfield2}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAdditionField.addfield3 !== 0 &&
                  showAdditionField.addfield3 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      New Field 3 : {showAdditionField.addfield3}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAdditionField.addfield4 !== 0 &&
                  showAdditionField.addfield4 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      New Field 4 : {showAdditionField.addfield4}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAdditionField.addfield5 !== 0 &&
                  showAdditionField.addfield5 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      New Field 5 : {showAdditionField.addfield5}
                    </p>
                  ) : (
                    <p></p>
                  )}
                </div>
              </div>
            </div>
          )}

          {showAssets && (
            // Display the popup when a row is selected
            <div className="popup">
              <div className="popup-content">
                <div className="note_popup_heading">
                  <div>
                    <h2>All Additional Assets</h2>
                  </div>
                  <div>
                    <button
                      className="note_popup_heading_close_btn"
                      onClick={() => {
                        SetshowAssets(false);
                      }}
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </button>
                  </div>
                </div>
                <div className="popup-body">
                  {showAssets.otherAsset.assetName !== 0 &&
                  showAssets.otherAsset.assetName !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      Other Field 1 : {showAssets.otherAsset.assetName}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAssets.otherAsset.otherAssets2 !== 0 &&
                  showAssets.otherAsset.otherAssets2 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      Other Field 2 : {showAssets.otherAsset.otherAssets2}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAssets.otherAsset.otherAssets3 !== 0 &&
                  showAssets.otherAsset.otherAssets3 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      Other Field 3 : {showAssets.otherAsset.otherAssets3}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAssets.otherAsset.otherAssets4 !== 0 &&
                  showAssets.otherAsset.otherAssets4 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      Other Field 4 : {showAssets.otherAsset.otherAssets4}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  {showAssets.otherAsset.otherAssets5 !== 0 &&
                  showAssets.otherAsset.otherAssets5 !== "" ? (
                    <p
                      style={{
                        fontWeight: 450,
                        fontSize: "12px",
                        color: "black",
                      }}
                    >
                      Other Field 5 : {showAssets.otherAsset.otherAssets5}
                    </p>
                  ) : (
                    <p></p>
                  )}
                </div>
              </div>
            </div>
          )}

          {/*  download popup */}
          {popupVisibleDownlaod && (
            <div className="popup">
              <div className="popup-content popup-content-download">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <h2>Download Files</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setPopupVisibleDownlaod(false);
                          setShow1(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>

                  <div>
                    {selectedDownlaod.documents &&
                      selectedDownlaod.documents.length > 0 &&
                      selectedDownlaod.documents.map((file, index) => (
                        <div key={index} style={{ marginBottom: "20px" }}>
                          <Tooltip title={file.fileName}>
                            <div
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                gap: "20px",
                              }}
                              onClick={() => {
                                handleDownload(file.id, file.fileName);
                              }}
                            >
                              Download - {index + 1}
                              <div className="myestate_download_button dwnbtn">
                                <FontAwesomeIcon
                                  className="myestate_download_icon"
                                  icon={faDownload}
                                />
                                <span>{file.fileName}</span>
                              </div>
                            </div>
                          </Tooltip>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          )}

          {beneficiaryVisible && (
            <div className="popup">
              <div className="popup-content popup-content-download">
                <div className="note_popup">
                  <div className="note_popup_heading">
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <h2>share property</h2>
                    </div>
                    <div>
                      <button
                        className="note_popup_heading_close_btn"
                        onClick={() => {
                          setBeneficiaryVisible(false);
                          setShow1(true);
                        }}
                      >
                        <FontAwesomeIcon icon={faXmark} />
                      </button>
                    </div>
                  </div>
                  <div>
                    {selectedBeneficiary.sharedDetails &&
                      selectedBeneficiary.sharedDetails.map(
                        (details, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              margin: "5px",
                              padding: "10px",
                              border: "solid 1px lightgray",
                              borderRadius: "5px",
                              minWidth: "230px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "17px",
                                  color: "black",
                                  fontWeight: "500",
                                }}
                              >
                                Share - {index + 1}
                              </p>
                              {primaryUserDetails.accountType === "secondary" &&
                              secondaryUserDetails.accountType === "primary" &&
                              secondaryUserDetails.isSecondaryUserEditable ===
                                "false" ? (
                                ""
                              ) : (
                                <FontAwesomeIcon
                                  onClick={() =>
                                    removeOtherAsset(
                                      details.id,
                                      "sharedDetailId"
                                    )
                                  }
                                  className="delete-button-comp"
                                  style={{ cursor: "pointer" }}
                                  icon={faTrash}
                                />
                              )}
                            </div>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                marginLeft: "20px",
                              }}
                            >
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Beneficiary Name:
                                <span style={{ marginLeft: "10px" }}>
                                  {getBenificiaryName(details.beneficiaryId)}
                                </span>
                              </p>
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Distributed Type:
                                <span style={{ marginLeft: "10px" }}>
                                  {details.distributedType}
                                </span>
                              </p>
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Distributed Value:{" "}
                                <span style={{ marginLeft: "10px" }}>
                                  {details &&
                                    details.distributedType === "dollar" &&
                                    "$"}
                                  {details.distributedValue}
                                  {details.distributedType === "percentage" &&
                                    "%"}
                                </span>
                              </p>
                              <p
                                style={{
                                  fontSize: "15px",
                                  color: "black",
                                  fontWeight: "400",
                                  marginLeft: "20px",
                                }}
                              >
                                Distributed Amount:
                                <span style={{ marginLeft: "10px" }}>
                                  {formatAmount(details.distributedAmount)}
                                </span>
                              </p>
                            </div>
                          </div>
                        )
                      )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {benevisible && (
            <SharedBeneficiary
              assetName={"otherAsset"}
              handleTrustSave={handleTrustSave}
              assetIndexValue={assetIndexValue}
              assetData={otherAssetList[assetIndexValue]?.otherAsset}
              trusts={trusts}
              handleChanges={handleChanges}
              sharedType={sharedTypeArray[assetIndexValue]}
              handleCloseBeneficiaryPopup={handleCloseBeneficiaryPopup}
              estimatedTotalAmount={
                otherAssetList[assetIndexValue]?.otherAsset?.assetValue
              }
              typeBeneficiary={"normal"}
              sharedDetails={otherAssetList[assetIndexValue]?.sharedDetails}
            />
          )}
        </SideBar>
      </UserBase>
    </div>
  );
}

export default OtherAssets;